import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noOption: {
		id: 'issue-table-grouping.group-row.group-header.option-group-header.no-option',
		defaultMessage: 'No value',
		description: 'Label for grouped items without option value',
	},
});
export default messages;
